const getters = {
  translationsArray: ({ translations }) => translations,

  newTranslationsArray: ({ newTranslations }) => newTranslations
}

export default getters
